<template>
  <v-text-field
    ref="textField"
    v-model="localValue"
    v-mask="phoneMask"
    class="phone-input"
    v-bind="$attrs"
    inputmode="tel"
    type="tel"
    :prefix="phonePrefix"
    :label="label"
    :error-messages="errorMessage"
  />
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { VTextField } from 'vuetify/components'

const PHONE_PREFIX = '+7 '

const props = defineProps({
  value: { type: String, default: '' },
  label: { type: String, default: 'Номер телефона' },
  customProps: { type: Object as PropType<Record<string, unknown>>, default: () => ({}) },
  errorMessage: { type: [Array, String] as PropType<string[] | string>, default: () => [] },
})

const emit = defineEmits(['update:value'])

const textField = ref<VTextField & { focused: boolean } | null>(null)

const phonePrefix = computed(() => {
  return textField.value?.focused || localValue.value ? PHONE_PREFIX : ''
})

const phoneMask = computed(() => ({
  mask: '&## ###-##-##',
  tokens: {
    '&': { pattern: /9/ },
    '#': { pattern: /\d/ },
  },
}))

const localValue = computed({
  get() {
    return props.value?.replace(PHONE_PREFIX, '')
  },
  set(value: string) {
    emit('update:value', (textField.value?.focused || value ? PHONE_PREFIX : '') + value)
  },
})

watch(() => localValue.value, async (value: string, oldValue: string) => {
  const input = textField.value?.$el.querySelector('input')

  if (
    value.length &&
    value.length < oldValue.length &&
    oldValue.startsWith('9') &&
    input &&
    input.selectionStart === 0
  ) {
    await nextTick()
    localValue.value = '9' + value
    await nextTick()
    input.setSelectionRange(1, 1)
  }
})
</script>

<style scoped lang="scss">
.phone-input {
  :deep(.v-text-field__prefix) {
    color: $t-ui-text!important;
    margin-right: -8px!important;
  }
}
</style>
